import Api from '../Base'

class GetUsers extends Api {
  requestUrl = '/api/user'
}

export default GetUsers
